import BasicResource from '@/api/resource';

class PayoutsResource extends BasicResource {

    constructor () {
        super('payouts');
    }
}

export default new PayoutsResource;